<template>
	<div class="body2">
		<gheader></gheader>
		<gnavigation activeIndex=2></gnavigation>
		<div class="main-body">
			<div class="location">
				当前位置: 
				<span v-for="(item,index) in location" :key="index">>>{{item}}</span>
			</div>

			<!-- 首页 >> 服务于民族文化、生态文明建设的“政用产学研”创新设计人才培养模式改革 >> 团队介绍 -->
			<div class="main-content">
				<gnavbutton v-bind="$attrs"></gnavbutton>
				<slot></slot>
			</div>
		</div>	
		<gfooter></gfooter>
	</div>
</template>

<script>
	import gnavbutton from "../navbutton.vue"
	export default {
		components:{
			gnavbutton,
		},
		props:{
			location:Array
		}
	}
</script>

<style lang="scss" scoped>
	/*page{
		display: flex;
		background-color: #F3F3F3;
		background-color: saddlebrown;
	}*/
	.body2{
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		
		.main-body{
			width: 1200px;
			display: flex;
			flex-direction: column;
			.location{
				text-align: left;
				margin: 10px 0;
				font-size: 1.8ch;
				color: #666;
			}
			.main-content{
				display: flex;
	
				.data{
					margin-left: 20px;
					flex: 1;
					height: 742px;
					justify-content: space-between;
					.title{
						margin-top: 10px;
						height:48px;
						line-height: 58px;
					}
					.data-content{
						height: 655pxl;
						
						margin-top: 10px;
						display: flex;
						flex-wrap: wrap;
						justify-content: space-around;
						.img-card{
							height: 286px;
							width: 200px;
							margin-bottom: 20px;
							display: flex;
							flex-direction: column;
							image{
								width: 100%;
								height: 234px;
							}
							.name{
								text-align: center;
								font-weight: 600;
								font-size: 1.6ch;
								margin: 8px 0;
							}
							.bottom{
								display: flex;
								justify-content: flex-end;
								font-size: 0.8ch;
								font-weight: 700;
								color: #999;
							}
						}
						.pages{
							margin: 14px 0;
						}
					}
				}
			}
		}
	}
	
</style>
